import React from 'react'
import { Trans, withI18n } from '@lingui/react'
import { node, string } from 'prop-types'
import classNames from 'classnames'

import { i18nType } from 'views/utils/propTypes/i18nType'

import getTranslatedOrStringValue from 'views/utils/getTranslatedOrStringValue'
import setInnerHTML from 'views/utils/setInnerHTML'

import LinkWithIcon from 'views/components/molecules/LinkWithIcon'

export const SliderHeader = ({
  title: titleRaw,
  moreLinkUrl,
  moreLinkTitle,
  i18n
}) => {
  const titleClassName = classNames('u-no-margin', {
    'l-flex__fill-gap@medium u-margin--right': moreLinkUrl
  })
  const title = getTranslatedOrStringValue(titleRaw, i18n) || '\u00A0'

  return (
    <div
      className="o-SliderHorizontal__header l-flex l-flex--wrap l-flex--distribute-space u-padding--bottom"
      data-clientside-hook="slider__header"
    >
      {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
      <h2 className={titleClassName} {...setInnerHTML(title)} />
      {moreLinkUrl && (
        <LinkWithIcon href={moreLinkUrl} icon="arrowRight" right>
          <span className="u-font-weight--bold">
            {moreLinkTitle || <Trans id="general.label.showAllResults" />}
          </span>
        </LinkWithIcon>
      )}
    </div>
  )
}
SliderHeader.propTypes = {
  i18n: i18nType.isRequired,
  title: node,
  moreLinkTitle: node,
  moreLinkUrl: string
}

SliderHeader.defaultProps = {
  title: null,
  moreLinkTitle: null,
  moreLinkUrl: null
}

export default withI18n()(SliderHeader)
